// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Ez-z","modalContent":"Fz-z","header":"Gz-z","close":"Hz-z"};